import React from 'react';

interface SectionHeaderProps {
  title: string;
  description: string;
}

function SectionHeader({ title, description }: SectionHeaderProps): React.ReactElement {
  return (
    <div className="mb-5">
      <h2 className="text-base font-semibold text-white">{title}</h2>
      <p className="text-gray-500 text-sm mt-0.5">{description}</p>
    </div>
  );
}

export default SectionHeader;
